import { Stack, Typography, styled } from "@mui/material"
import {
  EvolutionStatChip,
  type KeyFigure,
  formatNumber,
  formatPrice,
  isDefined,
  noDecimalsFormatOptions,
} from "@pharmupp/p3-front-commons"
import type { PropsWithChildren, ReactNode } from "react"

interface KPIDisplayProps {
  label: ReactNode
  value: ReactNode
}

const KPIDisplay = ({
  label,
  value,
  children,
}: PropsWithChildren<KPIDisplayProps>) => (
  <Stack spacing={2}>
    <Label>{label}</Label>
    <KPIValue>{value}</KPIValue>
    {children}
  </Stack>
)

const Label = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.dark,
  fontWeight: 600,
}))

const KPIValue = styled(Typography)(({ theme }) => ({
  color: theme.palette.common.darkBlue,
  fontWeight: 600,
}))
KPIValue.defaultProps = {
  variant: "h3",
}

export const PriceKPIDisplayEvolution = ({
  label,
  keyFigure,
}: {
  label: string
  keyFigure?: KeyFigure
}) => (
  <KPIDisplay
    label={label}
    value={
      isDefined(keyFigure?.mainStat)
        ? formatPrice(keyFigure.mainStat, noDecimalsFormatOptions)
        : "-"
    }
  >
    <Typography variant="28px">
      <EvolutionStatChip arrow bold border={false} evol={keyFigure?.evolution} />
    </Typography>
  </KPIDisplay>
)

export const PriceKPIDisplay = ({
  label,
  value,
}: {
  label: string
  value?: number | null
}) => (
  <KPIDisplay
    label={label}
    value={isDefined(value) ? formatPrice(value, noDecimalsFormatOptions) : "-"}
  />
)

export const NumberKPIDisplay = ({
  label,
  value,
}: {
  label: string
  value?: number | null
}) => (
  <KPIDisplay
    label={label}
    value={isDefined(value) ? formatNumber(value, noDecimalsFormatOptions) : "-"}
  />
)
